import React from "react";

export const calculatorNotes = [
  "Rates are indicative and subject to final confirmation.",
  "GST extra as applicable.",
  "Rates may vary based on grade, quantity, distance and pumping requirement.",
  "Transportation and pumping charges applicable as per site conditions.",
  "Final quantity and billing will be based on actual dispatch.",
  "Ensure site readiness and clear pump/TM access before dispatch.",
  "Pour duration and TM intervals are estimated under standard conditions.",
];

const CalculatorNotes = () => {
  return (
    <div className="mt-8 rounded-xl bg-yellow-50 border border-yellow-200 p-5">
      <h3 className="font-semibold mb-3">Important Notes</h3>

      <ul className="list-disc pl-5 space-y-2 text-sm text-gray-700">
        {calculatorNotes.map((note, index) => (
          <li key={index}>{note}</li>
        ))}
      </ul>
    </div>
  );
};

export default CalculatorNotes;
